<p-fieldset [legend]="'EMAIL_CONFIG.TITLE' | translate">
  <div class="grid">
    <div class="col-10">
      <p-inputSwitch [(ngModel)]="enableForAll"></p-inputSwitch>
      {{('EMAIL_CONFIG.SWITCH_LABEL' | translate) + " " + currentUser.idCustomer}}
    </div>
    <div class="col-2">
      <button pButton type="button" [icon]="'fa fa-key'" [label]="'COMMON.SAVE' | translate"
              (click)="saveEmailConfig()" class="p-button-warning"></button>
    </div>
    <div class="col-12" *ngIf="!enableForAll">
      <div *ngIf="!customerIDs || customerIDs.length === 0">
        {{'EMAIL_CONFIG.NO_ANALYTIC_ID'| translate}}
      </div>
      <div *ngIf="customerIDs && customerIDs.length > 0">
        <p-pickList [source]="availableIDs" [target]="selectedIDs"
        [sourceHeader]="'CL existants'" [targetHeader]="'CL sélectionnés'"
        [showSourceControls]="false" [showTargetControls]="false">
          <ng-template pTemplate="item" let-cl>
            <div>{{cl}}</div>
          </ng-template>
        </p-pickList>
      </div>
    </div>
  </div>
</p-fieldset>
